import { v4 as uuidv4 } from 'uuid';
import {DiseaseTreeLeafModel} from "@/entities/diseaseParameters/DiseaseTreeLeafModel";

export class DiseaseTreeBranchModel {
    id: string;
    label: string;
    children: (DiseaseTreeBranchModel | DiseaseTreeLeafModel)[];

    constructor(id: number, label: string, children: (DiseaseTreeBranchModel | DiseaseTreeLeafModel)[]) {
        this.id = uuidv4();
        this.label = label;
        this.children = children;
    }
}
